export default __webpack_public_path__ + "static/media/wrong.e9468218.mp3";